@if (showOffer && !finished) {
  @if (offerType === 'enrollment-promotion') {
    <div class="offer-container">
      <ng-container *ngTemplateOutlet="lottieContainer"></ng-container>
      <div class="background-box" [class.expanded]="isOpen && !isClosing" [class.fade-out]="isClosing">
        <div class="close" (click)="toggleExpand()">
          <i class="icon icon-close"></i>
        </div>
        <div class="title-container" [class.fade-in-up]="isToggled">
          <div class="upper-title">
            <h4 class="title">Crea tu cuenta y gana</h4>
          </div>
          <h2 class="promo">Hasta 20,000 MXN</h2>
          <p class="subtitle">Para utilizar en Mundo Hogar</p>
        </div>
        <div class="body-content" [class.fade-in-up]="isToggled">
          <div class="item">
            <img class="box" src="/assets/illustrations/account-award/big-prize.svg" alt="Imagen de premio mayor">
            <p class="subtitle">20,000 MXN</p>
          </div>
          <div class="item">
            <img class="box" src="/assets/illustrations/account-award/middle-prize.svg" alt="Imagen de premio mediano">
            <p class="subtitle">10,000 MXN</p>
          </div>
          <div class="item">
            <img class="box" src="/assets/illustrations/account-award/small-prize.svg" alt="Imagen de premio menor">
            <p class="subtitle">2,000 MXN</p>
          </div>
        </div>
        <div class="countdown-container" [class.fade-in-up]="isToggled">
          <div class="countdown-box">
            <div class="countdown-value">{{ days | number: '2.0-0' }}</div>
            <div class="countdown-label">Días</div>
          </div>
          <div class="countdown-box">
            <div class="countdown-value">{{ hours | number: '2.0-0' }}</div>
            <div class="countdown-label">Horas</div>
          </div>
          <div class="countdown-box">
            <div class="countdown-value">{{ minutes | number: '2.0-0' }}</div>
            <div class="countdown-label">Min.</div>
          </div>
          <div class="countdown-box">
            <div class="countdown-value">{{ seconds | number: '2.0-0' }}</div>
            <div class="countdown-label">Seg.</div>
          </div>
        </div>
        <div class="buttons-container" [class.fade-in-up]="isToggled">
          <app-button innerId="btn-JxoHMnad" label="Registrarse y participar" routerLink="/enrollment/sign-up" [queryParams]="{ offer: 'true' }" />
          <app-button innerId="btn-rvoaXJpM" class="legal" label="Bases legales" styleClass="tertiary dark" />
        </div>
      </div>
    </div>
  } @else if (offerType === 'home-assistance-promotion') {
    <div class="offer-container home-assistance-promotion">
      <ng-container *ngTemplateOutlet="lottieContainer"></ng-container>
      <div class="background-box" [class.expanded]="isOpen && !isClosing" [class.fade-out]="isClosing">
        <div class="close" (click)="toggleExpand()">
          <i class="icon icon-close"></i>
        </div>
        <div class="title-container" [class.fade-in-up]="isToggled">
          <div class="upper-title">
            <h4 class="title">Contrata tu plan de asistencia</h4>
          </div>
          <h2 class="promo">Desde 49.00 MXN al mes</h2>
        </div>
        <div class="body-content" [class.fade-in-up]="isToggled">
          <div class="item">
            <img class="box" src="/assets/images/home-plumbing.svg" alt="Imagen de plomería">
            <p class="subtitle">Plomería</p>
          </div>
          <div class="item">
            <img class="box" src="/assets/images/home-veterinary.svg" alt="Imagen de veterinario">
            <p class="subtitle">Veterinario</p>
          </div>
          <div class="item">
            <img class="box" src="/assets/images/many-more.svg" alt="Imagen de mucho más">
            <p class="subtitle">¡Y Mucho más!</p>
          </div>
        </div>
        <p class="limited-time" [class.fade-in-up]="isToggled">Oferta por tiempo limitado</p>
        <div class="countdown-container" [class.fade-in-up]="isToggled">
          <div class="countdown-box">
            <div class="countdown-value">{{ days | number: '2.0-0' }}</div>
            <div class="countdown-label">Días</div>
          </div>
          <div class="countdown-box">
            <div class="countdown-value">{{ hours | number: '2.0-0' }}</div>
            <div class="countdown-label">Horas</div>
          </div>
          <div class="countdown-box">
            <div class="countdown-value">{{ minutes | number: '2.0-0' }}</div>
            <div class="countdown-label">Min.</div>
          </div>
          <div class="countdown-box">
            <div class="countdown-value">{{ seconds | number: '2.0-0' }}</div>
            <div class="countdown-label">Seg.</div>
          </div>
        </div>
        <div class="buttons-container" [class.fade-in-up]="isToggled">
          <app-button innerId="btn-4ffgJZz0" class="plan-button" label="Elegir plan" routerLink="/home-assistance" [queryParams]="{ offer: 'true' }" (action)="close()" />
          <div class="offer-owner">
            <i class="icon icon-circle-checkmark"></i>
            <p class="text-container">
              <span class="disclaimer">Servicio entregado por</span>
              <img src="/assets/images/ike-logo.svg" class="logo" alt="Logo iké" />
            </p>
          </div>
        </div>
      </div>
    </div>
  } @else if (offerType === 'ecommerce-promotion') {
    <div class="offer-container ecommerce-promotion">
      <ng-container *ngTemplateOutlet="lottieContainer"></ng-container>
      <div class="background-box" [class.expanded]="isOpen && !isClosing" [class.fade-out]="isClosing">
        <div class="close" (click)="toggleExpand()">
          <i class="icon icon-close"></i>
        </div>
        <div class="title-container" [class.fade-in-up]="isToggled">
          <div class="upper-title">
            <h4 class="title">Exclusivo en Mundo Hogar</h4>
          </div>
          <h2 class="promo">Muebles y decoración para tu hogar</h2>
        </div>
        <div class="body-content" [class.fade-in-up]="isToggled">
          <div class="item">
            <img class="box" src="/assets/images/furniture-and-decoration.svg" alt="Imagen de muebles y decoración">
          </div>
        </div>
        <div class="content-ecommerce-container" [class.fade-in-up]="isToggled">
          <div class="item">
            <p class="text">Hasta</p>
            <p class="value">50<span class="symbol">%</span></p>
            <p class="disclaimer">De descuento en miles de productos</p>
          </div>
          <p class="separator">ó</p>
          <div class="item">
            <p class="text">Hasta</p>
            <p class="value">36<span class="symbol">MSI</span></p>
            <p class="disclaimer">Con tarjetas de crédito Santander</p>
          </div>
        </div>
        <div class="buttons-container" [class.fade-in-up]="isToggled">
          <app-button innerId="btn-4ffgJZz0" class="action-button" label="Ir a comprar" routerLink="/ecommerce/search" [queryParams]="queryParamsEcommercePromotion" (action)="close()" /> 
        </div>
      </div>
    </div>
  } @else if (offerType === 'ecommerce-mothers-day-promotion') {
    <div class="offer-container ecommerce-promotion">
      <ng-container *ngTemplateOutlet="lottieContainer"></ng-container>
      <div class="background-box" [class.expanded]="isOpen && !isClosing" [class.fade-out]="isClosing">
        <div class="close" (click)="toggleExpand()">
          <i class="icon icon-close"></i>
        </div>
        <div class="title-container" [class.fade-in-up]="isToggled">
          <span class="title">Para <span class="highlight">mamá</span>, <span class="disclaimer">el corazón del hogar</span></span>
          <span class="promo">Del 25 de Abril a 5 de Mayo</span>
        </div>
        <div class="content-ecommerce-container" [class.fade-in-up]="isToggled">
          <div class="item">
            <p class="text">Hasta</p>
            <p class="value">50<span class="symbol">%</span></p>
            <p class="disclaimer">De descuento en miles de productos</p>
          </div>
          <p class="separator">ó</p>
          <div class="item">
            <p class="text">Hasta</p>
            <p class="value">36<span class="symbol">MSI</span></p>
            <p class="disclaimer">Con tarjetas de crédito Santander</p>
          </div>
        </div>
        <img class="body-content" src="/assets/images/ecommerce-offer-01.jpg" alt="Imagen día de las madres" [class.fade-in-up]="isToggled">
        <div class="buttons-container" [class.fade-in-up]="isToggled">
          <app-button innerId="btn-4ffgJZz0" class="action-button" label="Ir a comprar" routerLink="/ecommerce/search" [queryParams]="queryParamsEcommercePromotion" (action)="close()" /> 
        </div>
      </div>
    </div>
  } @else if (offerType === 'ecommerce-fathers-day-promotion') {
    <div class="offer-container ecommerce-promotion">
      <ng-container *ngTemplateOutlet="lottieContainer"></ng-container>
      <div class="background-box" [class.expanded]="isOpen && !isClosing" [class.fade-out]="isClosing">
        <div class="close" (click)="toggleExpand()">
          <i class="icon icon-close"></i>
        </div>
        <div class="title-container" [class.fade-in-up]="isToggled">
          <span class="title">Para mi <span class="highlight">héroe</span>,<br><span class="disclaimer">¡felicidades papá!</span></span>
        </div>
        <div class="content-ecommerce-container" [class.fade-in-up]="isToggled">
          <div class="item">
            <p class="text">Hasta</p>
            <p class="value">50<span class="symbol">%</span></p>
            <p class="disclaimer">De descuento en miles de productos</p>
          </div>
          <p class="separator">ó</p>
          <div class="item">
            <p class="text">Hasta</p>
            <p class="value">36<span class="symbol">MSI</span></p>
            <p class="disclaimer">Con tarjetas de crédito Santander</p>
          </div>
        </div>
        <img class="body-content" src="/assets/images/ecommerce-fathers-day-promotion.jpg" alt="Imagen día del padre" [class.fade-in-up]="isToggled">
        <div class="buttons-container" [class.fade-in-up]="isToggled">
          <app-button innerId="btn-4ffgJZz0" class="action-button" label="Ir a comprar" routerLink="/ecommerce/search" [queryParams]="queryParamsEcommercePromotion" (action)="close()" /> 
        </div>
      </div>
    </div>
  } @else if (offerType === 'ecommerce-hot-sale-promotion') {
    <div class="offer-container ecommerce-promotion">
      <ng-container *ngTemplateOutlet="lottieContainer"></ng-container>
      <div class="background-box" [class.expanded]="isOpen && !isClosing" [class.fade-out]="isClosing">
        <div class="close" (click)="toggleExpand()">
          <i class="icon icon-close"></i>
        </div>
        <div class="title-container" [class.fade-in-up]="isToggled">
          <span class="title"><span class="highlight">Hot Sale</span> en <br>Mundo Hogar</span>
          <span class="promo">Del 26 de Mayo al 03 de Junio</span>
        </div>
        <div class="content-ecommerce-container" [class.fade-in-up]="isToggled">
          <div class="item">
            <p class="text">Hasta</p>
            <p class="value">60<span class="symbol">%</span></p>
            <p class="disclaimer">De descuento en miles de productos</p>
          </div>
          <p class="separator">ó</p>
          <div class="item">
            <p class="text">Hasta</p>
            <p class="value">36<span class="symbol">MSI</span></p>
            <p class="disclaimer">Con tarjetas de crédito Santander</p>
          </div>
        </div>
        <img class="body-content" src="/assets/images/ecommerce-hot-sale-promotion.jpg" alt="Imagen Hot Sale" [class.fade-in-up]="isToggled">
        <div class="buttons-container" [class.fade-in-up]="isToggled">
          <app-button innerId="btn-4ffgJZz0" class="action-button" label="Ir a comprar" routerLink="/ecommerce/search" [queryParams]="queryParamsEcommercePromotion" (action)="close()" /> 
        </div>
      </div>
    </div>
  } @else if (offerType === 'enrollment-new-account-promotion') {
    <div class="offer-container enrollment-promotion">
      <ng-container *ngTemplateOutlet="lottieContainer"></ng-container>
      <div class="background-box" [class.expanded]="isOpen && !isClosing" [class.fade-out]="isClosing">
        <div class="close" (click)="toggleExpand()">
          <i class="icon icon-close"></i>
        </div>
        <div class="title-container" [class.fade-in-up]="isToggled">
          <p class="title highlight">Crea tu cuenta</p>
          <span class="disclaimer">y accede a un mundo de beneficios</span>
        </div>
        <img class="body-content" src="/assets/images/enrollment-new-account-promotion.png" alt="Imagen crea tu cuenta y accede a beneficios" [class.fade-in-up]="isToggled">
        <div class="offers-container" [class.fade-in-up]="isToggled">
          <div class="offer">
            <i class="icon icon-circle-checkmark"></i>
            <p class="text">Proveedores calificados, servicios garantizados.</p>
          </div>
          <div class="offer">
            <i class="icon icon-circle-checkmark"></i>
            <p class="text">Alternativas de financiamiento exclusivas para clientes Santander.</p>
          </div>
          <div class="offer">
            <i class="icon icon-circle-checkmark"></i>
            <p class="text">¡Y mucho más!</p>
          </div>
        </div>
        <div class="buttons-container" [class.fade-in-up]="isToggled">
          <app-button innerId="btn-4ffgJZz0" class="action-button" label="Crear cuenta gratis" routerLink="/enrollment/sign-up" (action)="close()" /> 
        </div>
      </div>
    </div>
  } @else if (offerType === 'mortgage-simulator-promotion') {
    <div class="offer-container mortgage-simulator-promotion">
      <ng-container *ngTemplateOutlet="lottieContainer"></ng-container>
      <div class="background-box" [class.expanded]="isOpen && !isClosing" [class.fade-out]="isClosing">
        <div class="close" (click)="toggleExpand()">
          <i class="icon icon-close"></i>
        </div>
        <div class="title-container" [class.fade-in-up]="isToggled">
          <p class="title highlight">¿Estás comprando un inmueble?</p>
          <span class="disclaimer">Precalifica tu hipoteca Santander</span>
        </div>
        <img class="body-content" src="/assets/images/mortgage-simulator-promotion.webp" alt="Imagen precalifica tu hipoteca Santander" [class.fade-in-up]="isToggled">
        <div class="buttons-container" [class.fade-in-up]="isToggled">
          <app-button innerId="btn-4ffgJZz0" class="action-button" label="Simular hipoteca" routerLink="/mortgage-simulator" (action)="close()" /> 
        </div>
      </div>
    </div>
  }
  <ng-template #lottieContainer>
    <div (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" (click)="toggleExpand()" class="lottie-container">
      <div class="lottie-container">
        <div class="circle-shadow"></div>
        <ng-lottie class="image" [options]="{ autoplay: false, loop: false, path: '/assets/animations/lottie-bird.json' }" (animationCreated)="onAnimationCreated($event)">
        </ng-lottie>
      </div>
    </div>
  </ng-template>
}

